import { fetchWithAuth } from "./fetch-with-auth";
import { API_URL } from "constants/index";

/**
 * Resolves the IDs of EVERY document matching the given documents-overview
 * filters, across all pages (ignores pagination). Powers the Odoo-style
 * "select all matching" bulk action so a download can target the full filtered
 * result set rather than just the currently loaded rows.
 *
 * @param filterParams - the same filter query params used to list documents
 *   (search, buildingId, unitId, fileLabel, fileLogStatus, ownershipSituation).
 */
export async function fetchMatchingFileIds(
  filterParams: Record<string, string>,
  session: any,
): Promise<number[]> {
  if (!session) {
    throw new Error("Geen actieve sessie — log opnieuw in");
  }

  const queryParams = new URLSearchParams(filterParams).toString();
  const response = await fetchWithAuth(
    `${API_URL}/file/file-ids?${queryParams}`,
    { method: "GET" },
    session,
  );

  if (!response.ok) {
    throw new Error(`Kon documenten niet ophalen (${response.status})`);
  }

  const result = await response.json();
  return Array.isArray(result?.ids) ? result.ids : [];
}
